import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=2bec9446&scoped=true&lang=pug&"
import script from "./notification.vue?vue&type=script&lang=coffee&"
export * from "./notification.vue?vue&type=script&lang=coffee&"
import style0 from "./notification.vue?vue&type=style&index=0&id=2bec9446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec9446",
  null
  
)

export default component.exports